import { useEffect } from 'react';

import { useUserStore } from 'stores/use-user-store';

type UseRefreshUserOnMountOptions = {
	enabled?: boolean;
};

export const useRefreshUserOnMount = ({
	enabled = true,
}: UseRefreshUserOnMountOptions = {}) => {
	const refreshUser = useUserStore((state) => state.refreshUser);

	useEffect(() => {
		if (!enabled) {
			return;
		}

		void refreshUser();
	}, [enabled, refreshUser]);
};
